import gql from "graphql-tag";

export const MY_LEAVE_REJECT_REQUEST = gql`
  mutation rejectLeaveRequest(
    $_id: String!
    $message: String!
    $locale: String!
    $closedByAdmin: Boolean
    $role: String
  ) {
    rejectLeaveRequest(
      _id: $_id
      message: $message
      locale: $locale
      closedByAdmin: $closedByAdmin
      role: $role
    ) {
      _id
      state
      rejectedAt
      rejectedBy
    }
  }
`;
